import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Contact = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }

    // Handle checkbox state changes
    const handleCheckboxChange = (e) => {
      const checkbox = e.target;
      const checkboxSpan = checkbox.nextElementSibling;
      const icon = checkboxSpan.querySelector('i');
      
      if (checkbox.checked) {
        checkboxSpan.style.backgroundColor = 'var(--ul-primary)';
        checkboxSpan.style.borderColor = 'var(--ul-primary)';
        if (icon) icon.style.opacity = '1';
      } else {
        checkboxSpan.style.backgroundColor = 'var(--white)';
        checkboxSpan.style.borderColor = 'rgba(67, 67, 67, 0.3)';
        if (icon) icon.style.opacity = '0';
      }
    };

    const agreementCheckbox = document.getElementById('ul-contact-agreement');
    const newsletterCheckbox = document.getElementById('ul-contact-newsletter');

    if (agreementCheckbox) {
      agreementCheckbox.addEventListener('change', handleCheckboxChange);
    }
    if (newsletterCheckbox) {
      newsletterCheckbox.addEventListener('change', handleCheckboxChange);
    }

    return () => {
      if (agreementCheckbox) {
        agreementCheckbox.removeEventListener('change', handleCheckboxChange);
      }
      if (newsletterCheckbox) {
        newsletterCheckbox.removeEventListener('change', handleCheckboxChange);
      }
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value || '',
      role: e.target.role.value,
      subject: e.target.subject.value,
      message: e.target.message.value,
      newsletter: e.target.newsletter?.checked || false,
    };

    // Get role label
    const roleLabels = {
      'student-creative': 'Student Creative / Content Creator',
      'healthcare-mentor': 'Healthcare Mentor / Professional',
      'community-partner': 'Community Partner / Organization',
      'school-clinic': 'School or Clinic Partnership',
      'volunteer': 'Volunteer',
      'supporter': 'Supporter / Donor',
      'other': 'Other'
    };
    const roleLabel = roleLabels[formData.role] || formData.role;

    // Build email body
    let emailBody = `Name: ${formData.name}\n`;
    emailBody += `Email: ${formData.email}\n`;
    if (formData.phone) {
      emailBody += `Phone: ${formData.phone}\n`;
    }
    emailBody += `Interested In: ${roleLabel}\n\n`;
    emailBody += `Subject: ${formData.subject}\n\n`;
    emailBody += `Message:\n${formData.message}\n\n`;
    emailBody += `Newsletter Subscription: ${formData.newsletter ? 'Yes' : 'No'}`;

    // Encode the email body for mailto link
    const encodedBody = encodeURIComponent(emailBody);
    const encodedSubject = encodeURIComponent(formData.subject);
    
    // Create mailto link
    const mailtoLink = `mailto:pathio.org@gmail.com?subject=${encodedSubject}&body=${encodedBody}`;
    
    // Open email client
    window.location.href = mailtoLink;
  };

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

        <section className="ul-breadcrumb ul-section-spacing" style={{backgroundImage: "url('/assets/new-img/connections-between-people-groups-and-teams-2025-03-18-18-53-59-utc.jpg')"}}>
            <div className="ul-container">
                <h2 className="ul-breadcrumb-title">Contact Us</h2>
                <ul className="ul-breadcrumb-nav">
                    <li><Link to="/">Home</Link></li>
                    <li><span className="separator"><i className="flaticon-right"></i></span></li>
                    <li>Contact Us</li>
                </ul>
            </div>
        </section>

        <section className="ul-inner-contact ul-section-spacing">
            <div className="ul-container">
                <div className="ul-section-heading justify-content-center text-center" style={{marginBottom: 'clamp(40px, 4.21vw, 60px)'}}>
                    <div>
                        <h2 className="ul-section-title">Get Involved with Pathio</h2>
                        <p className="ul-section-descr" style={{maxWidth: '700px', margin: 'clamp(15px, 1.58vw, 25px) auto 0', fontSize: 'clamp(15px, 1.05vw, 18px)', lineHeight: 1.8}}>
                            Pathio welcomes professionals, organizations, and community partners who want to support peer mentorship, healthcare pathway navigation, and initiatives that raise awareness around health and access to care.
                        </p>
                    </div>
                </div>

                <div className="row gx-5 gy-4">

                    <div className="col-lg-8">
                        <div className="ul-inner-contact-container" style={{background: 'var(--white)', padding: 'clamp(30px, 3.15vw, 50px)', borderRadius: 'clamp(15px, 1.05vw, 20px)', boxShadow: '0 5px 30px rgba(0, 0, 0, 0.08)'}}>
                            <form onSubmit={handleSubmit} className="ul-contact-form ul-form">
                                <div className="row row-cols-md-2 row-cols-1 ul-bs-row">

                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="ul-contact-name" style={{display: 'block', marginBottom: 'clamp(8px, 0.84vw, 12px)', fontWeight: 600, color: 'var(--ul-black)', fontSize: 'clamp(14px, 0.95vw, 16px)'}}>
                                                Full Name <span style={{color: 'var(--ul-primary)'}}>*</span>
                                            </label>
                                            <input type="text" name="name" id="ul-contact-name" placeholder="Enter your full name" required style={{width: '100%', padding: 'clamp(12px, 1.26vw, 18px)', border: '1px solid rgba(67, 67, 67, 0.2)', borderRadius: 'clamp(8px, 0.63vw, 10px)', fontSize: 'clamp(14px, 0.95vw, 16px)', transition: '0.3s ease'}} />
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="ul-contact-email" style={{display: 'block', marginBottom: 'clamp(8px, 0.84vw, 12px)', fontWeight: 600, color: 'var(--ul-black)', fontSize: 'clamp(14px, 0.95vw, 16px)'}}>
                                                Email Address <span style={{color: 'var(--ul-primary)'}}>*</span>
                                            </label>
                                            <input type="email" name="email" id="ul-contact-email" placeholder="your.email@example.com" required style={{width: '100%', padding: 'clamp(12px, 1.26vw, 18px)', border: '1px solid rgba(67, 67, 67, 0.2)', borderRadius: 'clamp(8px, 0.63vw, 10px)', fontSize: 'clamp(14px, 0.95vw, 16px)', transition: '0.3s ease'}} />
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="ul-contact-phone" style={{display: 'block', marginBottom: 'clamp(8px, 0.84vw, 12px)', fontWeight: 600, color: 'var(--ul-black)', fontSize: 'clamp(14px, 0.95vw, 16px)'}}>
                                                Phone Number <span style={{color: '#999', fontWeight: 400}}>(Optional)</span>
                                            </label>
                                            <input type="tel" name="phone" id="ul-contact-phone" placeholder="(555) 123-4567" style={{width: '100%', padding: 'clamp(12px, 1.26vw, 18px)', border: '1px solid rgba(67, 67, 67, 0.2)', borderRadius: 'clamp(8px, 0.63vw, 10px)', fontSize: 'clamp(14px, 0.95vw, 16px)', transition: '0.3s ease'}} />
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="ul-contact-role" style={{display: 'block', marginBottom: 'clamp(8px, 0.84vw, 12px)', fontWeight: 600, color: 'var(--ul-black)', fontSize: 'clamp(14px, 0.95vw, 16px)'}}>
                                                I'm interested in <span style={{color: 'var(--ul-primary)'}}>*</span>
                                            </label>
                                            <select name="role" id="ul-contact-role" required style={{width: '100%', padding: 'clamp(12px, 1.26vw, 18px) !important', paddingRight: 'clamp(40px, 3.15vw, 50px) !important', paddingLeft: 'clamp(12px, 1.26vw, 18px) !important', height: 'auto !important', minHeight: 'clamp(44px, 3.68vw, 54px)', border: '1px solid rgba(67, 67, 67, 0.2)', borderRadius: 'clamp(8px, 0.63vw, 10px)', fontSize: 'clamp(14px, 0.95vw, 16px)', backgroundColor: 'var(--white)', transition: '0.3s ease', cursor: 'pointer', appearance: 'auto', WebkitAppearance: 'menulist', MozAppearance: 'menulist', backgroundImage: 'none', lineHeight: '1.5', boxSizing: 'border-box'}}>
                                                <option value="">Select an option</option>
                                                <option value="student-creative">Student Creative / Content Creator</option>
                                                <option value="healthcare-mentor">Healthcare Mentor / Professional</option>
                                                <option value="community-partner">Community Partner / Organization</option>
                                                <option value="school-clinic">School or Clinic Partnership</option>
                                                <option value="volunteer">Volunteer</option>
                                                <option value="supporter">Supporter / Donor</option>
                                                <option value="other">Other</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12" style={{width: '100%', flex: '0 0 100%', maxWidth: '100%'}}>
                                        <div className="form-group">
                                            <label htmlFor="ul-contact-subject" style={{display: 'block', marginBottom: 'clamp(8px, 0.84vw, 12px)', fontWeight: 600, color: 'var(--ul-black)', fontSize: 'clamp(14px, 0.95vw, 16px)'}}>
                                                Subject <span style={{color: 'var(--ul-primary)'}}>*</span>
                                            </label>
                                            <input type="text" name="subject" id="ul-contact-subject" placeholder="Brief description of how you'd like to get involved" required style={{width: '100%', padding: 'clamp(12px, 1.26vw, 18px)', border: '1px solid rgba(67, 67, 67, 0.2)', borderRadius: 'clamp(8px, 0.63vw, 10px)', fontSize: 'clamp(14px, 0.95vw, 16px)', transition: '0.3s ease'}} />
                                        </div>
                                    </div>

                                    <div className="col-12" style={{width: '100%', flex: '0 0 100%', maxWidth: '100%'}}>
                                        <div className="form-group">
                                            <label htmlFor="ul-contact-msg" style={{display: 'block', marginBottom: 'clamp(8px, 0.84vw, 12px)', fontWeight: 600, color: 'var(--ul-black)', fontSize: 'clamp(14px, 0.95vw, 16px)'}}>
                                                Message <span style={{color: 'var(--ul-primary)'}}>*</span>
                                            </label>
                                            <textarea name="message" id="ul-contact-msg" rows="6" placeholder="Tell us more about yourself, your background, and how you'd like to contribute to Pathio's mission..." required style={{width: '100%', padding: 'clamp(12px, 1.26vw, 18px)', border: '1px solid rgba(67, 67, 67, 0.2)', borderRadius: 'clamp(8px, 0.63vw, 10px)', fontSize: 'clamp(14px, 0.95vw, 16px)', fontFamily: 'inherit', resize: 'vertical', transition: '0.3s ease', minHeight: '150px'}}></textarea>
                                        </div>
                                    </div>

                                    <div className="col-12" style={{width: '100%', flex: '0 0 100%', maxWidth: '100%'}}>
                                        <div className="form-group" style={{marginBottom: 'clamp(12px, 1.26vw, 16px)'}}>
                                            <label className="ul-checkbox-wrapper" style={{display: 'flex', alignItems: 'start', gap: 'clamp(10px, 1.05vw, 15px)', cursor: 'pointer'}}>
                                                <input type="checkbox" name="agreement" id="ul-contact-agreement" required style={{display: 'none'}} />
                                                <span className="ul-checkbox" style={{flexShrink: 0, marginTop: '3px', width: 'clamp(17px, 1.05vw, 20px)', height: 'clamp(17px, 1.05vw, 20px)', border: '1px solid rgba(67, 67, 67, 0.3)', borderRadius: '4px', backgroundColor: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s ease'}}>
                                                    <i className="flaticon-tick" style={{opacity: 0, color: 'var(--white)', fontSize: '10px', transition: 'opacity 0.3s ease'}}></i>
                                                </span>
                                                <span className="ul-checkbox-txt" style={{fontSize: 'clamp(13px, 0.89vw, 15px)', lineHeight: 1.6, color: 'var(--ul-p)'}}>
                                                    I agree to be contacted by Pathio regarding my inquiry and understand that my information will be used in accordance with Pathio's <Link to="/privacy" style={{color: 'var(--ul-primary)', textDecoration: 'underline'}}>Privacy Policy</Link>. <span style={{color: 'var(--ul-primary)'}}>*</span>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="form-group" style={{marginBottom: 0}}>
                                            <label className="ul-checkbox-wrapper" style={{display: 'flex', alignItems: 'start', gap: 'clamp(10px, 1.05vw, 15px)', cursor: 'pointer'}}>
                                                <input type="checkbox" name="newsletter" id="ul-contact-newsletter" style={{display: 'none'}} />
                                                <span className="ul-checkbox" style={{flexShrink: 0, marginTop: '3px', width: 'clamp(17px, 1.05vw, 20px)', height: 'clamp(17px, 1.05vw, 20px)', border: '1px solid rgba(67, 67, 67, 0.3)', borderRadius: '4px', backgroundColor: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s ease'}}>
                                                    <i className="flaticon-tick" style={{opacity: 0, color: 'var(--white)', fontSize: '10px', transition: 'opacity 0.3s ease'}}></i>
                                                </span>
                                                <span className="ul-checkbox-txt" style={{fontSize: 'clamp(13px, 0.89vw, 15px)', lineHeight: 1.6, color: 'var(--ul-p)'}}>
                                                    I'd like to receive updates about Pathio's programs, campaigns, and opportunities (optional)
                                                </span>
                                            </label>
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 'clamp(20px, 2.1vw, 30px)'}}>
                                            <button type="submit" className="ul-btn" style={{minWidth: '200px'}}>
                                                <i className="flaticon-fast-forward-double-right-arrows-symbol"></i> Send Message
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div style={{background: 'linear-gradient(135deg, var(--ul-primary) 0%, var(--ul-secondary) 100%)', padding: 'clamp(30px, 3.15vw, 50px)', borderRadius: 'clamp(15px, 1.05vw, 20px)', color: 'var(--white)', height: '100%'}}>
                            <h3 style={{color: 'var(--white)', marginBottom: 'clamp(20px, 2.1vw, 30px)', fontSize: 'clamp(22px, 1.68vw, 28px)'}}>Ways to Get Involved</h3>

                            <div style={{marginBottom: 'clamp(25px, 2.63vw, 35px)'}}>
                                <div style={{display: 'flex', alignItems: 'start', gap: 'clamp(12px, 1.26vw, 18px)', marginBottom: 'clamp(20px, 2.1vw, 25px)'}}>
                                    <div style={{width: 'clamp(40px, 2.63vw, 50px)', height: 'clamp(40px, 2.63vw, 50px)', background: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                                        <i className="flaticon-team" style={{color: 'var(--white)', fontSize: 'clamp(18px, 1.26vw, 22px)'}}></i>
                                    </div>
                                    <div>
                                        <h4 style={{color: 'var(--white)', marginBottom: 'clamp(5px, 0.53vw, 8px)', fontSize: 'clamp(16px, 1.16vw, 20px)'}}>Student Creatives</h4>
                                        <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: 'clamp(14px, 0.95vw, 16px)', lineHeight: 1.6, margin: 0}}>Join media sprints, create visual explainers, and build your portfolio with real-world impact.</p>
                                    </div>
                                </div>

                                <div style={{display: 'flex', alignItems: 'start', gap: 'clamp(12px, 1.26vw, 18px)', marginBottom: 'clamp(20px, 2.1vw, 25px)'}}>
                                    <div style={{width: 'clamp(40px, 2.63vw, 50px)', height: 'clamp(40px, 2.63vw, 50px)', background: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                                        <i className="flaticon-team" style={{color: 'var(--white)', fontSize: 'clamp(18px, 1.26vw, 22px)'}}></i>
                                    </div>
                                    <div>
                                        <h4 style={{color: 'var(--white)', marginBottom: 'clamp(5px, 0.53vw, 8px)', fontSize: 'clamp(16px, 1.16vw, 20px)'}}>Healthcare Mentors</h4>
                                        <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: 'clamp(14px, 0.95vw, 16px)', lineHeight: 1.6, margin: 0}}>Share your expertise and mentor the next generation of healthcare communicators.</p>
                                    </div>
                                </div>

                                <div style={{display: 'flex', alignItems: 'start', gap: 'clamp(12px, 1.26vw, 18px)', marginBottom: 'clamp(20px, 2.1vw, 25px)'}}>
                                    <div style={{width: 'clamp(40px, 2.63vw, 50px)', height: 'clamp(40px, 2.63vw, 50px)', background: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                                        <i className="flaticon-relationship" style={{color: 'var(--white)', fontSize: 'clamp(18px, 1.26vw, 22px)'}}></i>
                                    </div>
                                    <div>
                                        <h4 style={{color: 'var(--white)', marginBottom: 'clamp(5px, 0.53vw, 8px)', fontSize: 'clamp(16px, 1.16vw, 20px)'}}>Partners</h4>
                                        <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: 'clamp(14px, 0.95vw, 16px)', lineHeight: 1.6, margin: 0}}>Schools, clinics, and organizations can partner with us to expand our reach.</p>
                                    </div>
                                </div>

                                <div style={{display: 'flex', alignItems: 'start', gap: 'clamp(12px, 1.26vw, 18px)'}}>
                                    <div style={{width: 'clamp(40px, 2.63vw, 50px)', height: 'clamp(40px, 2.63vw, 50px)', background: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                                        <i className="flaticon-love" style={{color: 'var(--white)', fontSize: 'clamp(18px, 1.26vw, 22px)'}}></i>
                                    </div>
                                    <div>
                                        <h4 style={{color: 'var(--white)', marginBottom: 'clamp(5px, 0.53vw, 8px)', fontSize: 'clamp(16px, 1.16vw, 20px)'}}>Supporters</h4>
                                        <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: 'clamp(14px, 0.95vw, 16px)', lineHeight: 1.6, margin: 0}}>Help us expand our programs and reach more communities through donations and support.</p>
                                    </div>
                                </div>
                            </div>

                            <div style={{paddingTop: 'clamp(25px, 2.63vw, 35px)', borderTop: '1px solid rgba(255, 255, 255, 0.2)'}}>
                                <p style={{color: 'rgba(255, 255, 255, 0.95)', fontSize: 'clamp(14px, 0.95vw, 16px)', lineHeight: 1.7, marginBottom: 'clamp(15px, 1.58vw, 20px)'}}>
                                    Have questions? We're here to help you find the best way to contribute to our mission.
                                </p>
                                <a href="mailto:pathio.org@gmail.com" style={{color: 'var(--white)', fontWeight: 600, fontSize: 'clamp(15px, 1.05vw, 18px)', textDecoration: 'underline'}}>
                                    pathio.org@gmail.com
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </main>

      <Footer />
    </>
  );
};

export default Contact;
